import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllFacilities } from "../services/api";

const initialState = {
  facilities: [],
  status: "idle",
  error: null,
  loading: false,
  initialized: false
};

export const fetchAllFacilities = createAsyncThunk(
  "facilities/fetchAllFacilities",
  async () => {
    try {
      const response = await getAllFacilities();
      // Handle different possible response structures
      const facilitiesData = response.data?.facilities || response.data || [];
      return Array.isArray(facilitiesData) ? facilitiesData : [];
    } catch (error) {
      throw error;
    }
  }
);

const facilitySlice = createSlice({
  name: "facilities",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllFacilities.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllFacilities.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.facilities = action.payload;
        state.initialized = true;
        state.error = null;
      })
      .addCase(fetchAllFacilities.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.error.message;
        state.initialized = true;
        state.facilities = [];
      });
  },
});

export default facilitySlice.reducer;